const Page404: React.FC = () => <p>Not found.</p>;

export default Page404;
